import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  sourceCreateDialogStepper: {
    backgroundColor: theme.vars.palette.background.default
  },
  fieldLoading: {
    display: 'flex',
    gap: '.5rem',
    padding: '.5rem',
    border: '1px solid',
    borderColor: theme.vars.palette.border.light,
    maxHeight: 'calc(100% - 64px)',
    height: '2.75rem',
    borderRadius: 'var(--mui-shape-borderRadius)'
  },
  loadingBox: {
    right: '12px',
    top: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  loadingText: {
    fontSize: '0.75rem',
    marginTop: '4px'
  }
}));

export default useStyles;
